var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M39.994,45.998l-3.988,0l0.014,-8.018l-8.018,0.014l0,-3.988l7.976,-0.028l0.028,-7.976l3.988,0l0.028,7.976l7.976,0.028l0,3.988l-8.018,-0.014l0.014,8.018Zm-3.994,-37.998l-0.16,0l-13.84,13.84l0,23.98l-8,-8l0,-16l-13.82,-13.82l-0.18,0l0,-4l36,0l0,4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFilter);
export default __webpack_public_path__ + "static/media/add-filter.ea67d3b37d6a9a1d474be2e54c165a0d.svg";
export { ForwardRef as ReactComponent };